import React from 'react'
import { func, string } from 'prop-types'
import styled from 'styled-components'

import { greyDark } from 'styles/colors'
import { fontWeights, fontSizes } from 'styles/typography'
import Icon from 'components/Icon'
import * as spacing from 'styles/spacing'

import LeftArrow from 'icons/left-arrow.svg'

export const Back = styled.button`
  display: flex;
  align-items: center;
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.medium};
  color: ${greyDark};
`

const Label = styled.span`
  margin-left: ${spacing.tiny};
`

const StepBack = ({ setStep, initialstep }) => {
  return (
    <Back
      onClick={() => {
        setStep(initialstep)
      }}
    >
      <Icon icon={<LeftArrow />} />
      <Label>Back</Label>
    </Back>
  )
}

StepBack.propTypes = {
  setStep: func.isRequired,
  initialstep: string.isRequired
}

export default StepBack
